import { useEffect, useState } from "react";

export default function useOutsideClick(ref) {
  const [clickedOutside, setClickedOutside] = useState(false)

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setClickedOutside(true);
      }
    }

    function handleClickFinished(event) {
      setClickedOutside(false);
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("mouseup", handleClickFinished);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return clickedOutside;
}

